<template lang="pug">
    include DesarrolloEmpresarial.pug
</template>

<script>
import _ from "underscore";
import Api from "@/components/services/Api";

export default {
    name: 'DesarrolloEmpresarial',
    data() {
        return {
            categories: [],
            category: null,
            images: {},
            internalCategories: [],
            intro: [],
            layout: "layout-regular",
            seed: null,
        };
    },
    created() {
        this.loadCategory("haz-crecer-tu-negocio");
    },
    methods: {
        loadCategory(slug) {
            const _this = this;

            Api.getCategoryBySlug(slug).then(response => {
                Api.getCategoriesByParent(response.data.id).then(response => {
                    _this.categories = response.data.items;
                    _this.changeCategory(_.first(_this.categories))
                });
            }).catch();
        },
        goToCategory(item) {
            this.$router.push({name: "Category", params: { slug: item.slug }});
        },
        changeCategory(item) {
            const _this = this;
            const token = this.$store.state.token;
            let categoryId = item.id;
            this.category = item;
            this.intro = [];
            let introTags = [];

            // Get all the entries (put "intro" tagged first
            Api.getEntriesByParent(categoryId, token).then(resp => {
                let entries = _.map(resp.data.items, item => {
                    item.tags = Api.translateTags(item.tags);
                    introTags = _.union(introTags, item.tags);

                    return item;
                });

                // Separate intro first
                let intro = _.filter(entries, entry => {
                    return _.contains(entry.tags, "intro");
                });

                // Decide the layout
                if (_.contains(introTags, "layout-boxes")) _this.layout = "layout-boxes";
                if (_.contains(introTags, "layout-boxes-row")) _this.layout = "layout-boxes-row";
                if (_.contains(introTags, "icon-boxes")) _this.layout = "icon-boxes";

                if (!_.isArray(intro)) intro = [];
                _this.intro = intro;

                // Get all categories to be shown inside the template
                Api.getCategoriesByParent(categoryId).then(resp => {
                    _this.internalCategories = _.map(resp.data.items, item => {
                        return item;
                    });
                }).catch(err => {
                });
            }).catch(err => {});

        }
    }
}

</script>

<style scoped lang="scss">
@import "./../../variables";
@import "DesarrolloEmpresarial";
</style>



// WEBPACK FOOTER //
// src/components/desarrollo_empresarial/DesarrolloEmpresarial.vue